<template>
  <div id="app">
    <!-- <keep-alive include="bloggerlist">
      <router-view v-if="isRouterAlive" />
    </keep-alive> -->
    <keep-alive :include="cachedViews" :max="15">
      <router-view :key="key" />
    </keep-alive>
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view> -->
  </div>
</template>

<script>
import { getUserInfo, getStatusHeight } from "@/plugins/webview";
import store from "./store";
export default {
  name: "app",
  components: {},
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const {
          name,
          meta: { keepAlive },
        } = route;
        console.log(this.$store.state.cachedViews.cachedViews,'this.$store.state.cachedViews.cachedViews')
        if (name && keepAlive) {
          this.$store.commit("cachedViews/ADD_CACHED_VIEW", route);
        }
      },
    },
  },
  computed: {
    cachedViews() {
      return this.$store.state.cachedViews.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
  beforeCreate() {
    getUserInfo((res) => {
      localStorage.setItem("token", res.token);
      localStorage.setItem("opsToken", res.opsToken);
      store.dispatch("Login", res);
    });
    getStatusHeight((res) => {
      store.commit("UpdateStatusheight", res.height * 1 || 20);
    });
  },
};
</script>
 
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
</style>
